// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvoiceAmountsController from "./invoice_amounts_controller"
application.register("invoice-amounts", InvoiceAmountsController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)
